import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/*
path:路由路径
*/
export const constantRouterMap = [
	//mobile路由
	{
		path: '/',
		component: () => import('@/pages/pc.vue'),
		name: 'pc',
		meta: {
			title: 'pc',
		},
	},
	//pc路由
	{
		path: '/mobile',
		component: () => import('@/pages/mobile.vue'),
		name: 'mobile',
		meta: {
			title: 'mobile',
		},
	},

]

export default new Router({
	// mode: 'history', 
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRouterMap
})
